function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#2696A1;}\n");

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "60.7,42.2 60.7,42.2 60.7,42.2 60.7,42.2 60.7,42.2 "
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "60.7,42.2 60.7,42.2 60.7,42.2 60.7,42.2 "
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M3.8,84.6C3.8,84.5,3.8,84.5,3.8,84.6C3.8,84.5,3.8,84.5,3.8,84.6C3.8,84.5,3.8,84.5,3.8,84.6L3.8,84.6 L3.8,84.6z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M37.9,23.1C37.9,23.1,37.9,23.2,37.9,23.1c-2.4,1.8-4.4,4.3-6.5,6.4c-3.2,4.3-6.3,8.8-9.4,13.2 c-4.2-1.6-7.6-4.2-11.7-5.8c-2.5-1.2-4.9-2.8-7.4-4.1c-0.3,0.2-0.6,0.5-0.9,0.8C3,39.3,4.9,44.8,7.5,49.9c1.2,2,2.5,3.8,3.8,5.7 c-4.8,5.9-6.5,12.3-9.4,19c-0.8,3-1.1,6.2-1.8,9.2C0.1,83.9,0.1,84,0.2,84L0,84.2l0.3-0.1c0.2,0.2,0.5,0.4,0.9,0.5 c2.9-3.3,6.5-6.2,9.3-9.6c1.1-1.3,2.5-2.4,3.4-4l-0.4,0.4c1.1-1.5,3-3.2,4.5-4.4c3.9,6.9,8.8,17.5,14.7,24.3 c1.8,2.1,3.4,4.4,5.1,6.6c1.6-1.1,0-3.1-0.1-4.5c-0.2-1-0.5-2.2-0.7-3.2c-1.4-11.3-2.1-22.4-1.5-34c5-1.8,9.6-4.6,14.3-7.1 c2.5-1.3,5-2.8,7.3-4.4c1.7-1.1,3.5-2.3,5-3.7c-2-0.8-3.9,0.4-5.8,0.9c-0.9,0.3-2,0.9-3,0.8c-3.9,0.7-7.8,1.6-11.8,1.6 c-1.8-0.1-3.6,0-5.4,0.2c0.4-4.5,0.7-10.3,1.3-14.6C37.2,27.7,39.5,25.2,37.9,23.1L37.9,23.1L37.9,23.1z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M256.3,0.8C220.8,2.5,186,6.9,150.5,8.4C125.3,8.9,87.3,7,66.1,21.2c23.4-0.9,45,8.2,68.7,6.6 c43.1,0.5,84-4.4,122.5-26.9C256.9,0.8,256.6,0.8,256.3,0.8L256.3,0.8L256.3,0.8z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M285.4,48.3c-14,4.2-31.7,0.6-45.4,1.2c-20.3,0.1-45.4,2.8-64.1,2.8c-21.3,0.5-41.7-0.1-63.3,2.5 c-15.7,1.5-30.8,5.6-45.1,10.4c-2.5,1.5-8.7,0.4-9.9,2.9c1.4,11.6,63.4,1.2,74.9,2.9C176.2,69.9,252.3,79.1,285.4,48.3 C285.5,48.4,285.4,48.3,285.4,48.3L285.4,48.3L285.4,48.3z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M281.2,84.7c-58.4,11.2-176.3-16.3-219.5,22.2c17.6-6,35.4-1.7,53.8-1.9c20.6-0.6,41.2-0.4,61.8-0.5 c42.3,0.7,66.6,5.8,103.8-19.7C281.2,84.8,281.2,84.7,281.2,84.7L281.2,84.7L281.2,84.7z"
});

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Draw_Layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 285.4 108.8",
    style: {
      enableBackground: "new 0 0 285.4 108.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.f36dec3b.svg";
export { ForwardRef as ReactComponent };